<div style="padding: 8px">
  <h3>Selektierte Felder für alle Positionen übernehmen</h3>

  <div class="dialog-layout">
    <div class="layout-edit-form">
      <mat-form-field style="width: 100%">
        <mat-label>Abnahmetermin</mat-label>
        <input
          matInput
          [matDatepicker]="datepicker"
          [(ngModel)]="data.acceptanceDate"/>
        <mat-datepicker-toggle
          matIconSuffix
          [for]="datepicker"></mat-datepicker-toggle>
        <mat-datepicker #datepicker></mat-datepicker>
      </mat-form-field>
    </div>
    <div>
      {{ joinFields('acceptanceDate', 'date') }}
    </div>
    <div class="layout-edit-form">
      <mat-form-field>
        <mat-label>Späteste Freigabe Konstruktion</mat-label>
        <input
          matInput
          [matDatepicker]="datepickerConst"
          [(ngModel)]="data.latestReleaseConstDate"/>
        <mat-datepicker-toggle
          matIconSuffix
          [for]="datepickerConst"></mat-datepicker-toggle>
        <mat-datepicker #datepickerConst></mat-datepicker>
      </mat-form-field>
    </div>
    <div>{{ joinFields('latestReleaseConstDate', 'date') }}</div>

    <div class="layout-edit-form">
      <mat-form-field>
        <mat-label>Späteste Freigabe Spezifikation</mat-label>
        <input
          matInput
          [matDatepicker]="datepickerSpec"
          [(ngModel)]="data.latestReleaseSpecDate"/>
        <mat-datepicker-toggle
          matIconSuffix
          [for]="datepickerSpec"></mat-datepicker-toggle>
        <mat-datepicker #datepickerSpec></mat-datepicker>
      </mat-form-field>
    </div>
    <div>{{ joinFields('latestReleaseSpecDate', 'date') }}</div>

    <div class="layout-edit-form">
      <mat-form-field>
        <mat-label>Startgespräch</mat-label>
        <input
          matInput
          [matDatepicker]="datepickerKickoff"
          [(ngModel)]="data.kickoffDate"/>
        <mat-datepicker-toggle
          matIconSuffix
          [for]="datepickerKickoff"></mat-datepicker-toggle>
        <mat-datepicker #datepickerKickoff></mat-datepicker>
      </mat-form-field>
    </div>
    <div>{{ joinFields('kickoffDate', 'date') }}</div>

    <div class="layout-edit-form">
      <mat-form-field>
        <mat-label>Externer Planer</mat-label>
        <mat-select [(ngModel)]="data.extPlannerId">
          <mat-option
            *ngFor="let planner of planners$ | async"
            [value]="planner.OBJECT_ID">
            {{ planner.TEXT }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>{{ joinFields('extPlannerText') }}</div>

    <div class="layout-edit-form">
      <mat-form-field>
        <mat-label>Externer Messtechniker</mat-label>
        <mat-select [(ngModel)]="data.extMetrologistId">
          <mat-option
            *ngFor="let metrologist of metrologists$ | async"
            [value]="metrologist.OBJECT_ID">
            {{ metrologist.TEXT }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>{{ joinFields('extMetrologistText') }}</div>

    <div class="layout-edit-form">
      <mat-form-field>
        <mat-label>Fertigungsfortschritt</mat-label>
        <input matInput [(ngModel)]="data.productionProgress"/>
        <mat-icon matSuffix>percent</mat-icon>
      </mat-form-field>
    </div>
    <div>{{ joinFields('productionProgress', 'percent') }}</div>

    <div class="ps-flex-container-row" style="grid-column: auto / span 2">
      <div style="flex: 1 0 auto"></div>
      <button mat-button color="primary" (click)="save()">SPEICHERN</button>
      <button mat-button color="primary" (click)="dismiss()">VERWERFEN</button>
    </div>
  </div>
</div>
